var map = {
	"./en/app.json": 4982,
	"./en/credit-card-payment.json": 5088,
	"./en/payment-complete.json": 990,
	"./es/app.json": 5954,
	"./es/credit-card-payment.json": 6897,
	"./es/payment-complete.json": 8476,
	"./zh-Hans/app.json": 3699,
	"./zh-Hans/credit-card-payment.json": 4546,
	"./zh-Hans/payment-complete.json": 9376,
	"./zh-Hant/app.json": 5426,
	"./zh-Hant/credit-card-payment.json": 2695,
	"./zh-Hant/payment-complete.json": 2547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;